import { render, staticRenderFns } from "./CreditsPage.vue?vue&type=template&id=46f77815&scoped=true"
import script from "./CreditsPage.vue?vue&type=script&lang=ts"
export * from "./CreditsPage.vue?vue&type=script&lang=ts"
import style0 from "./CreditsPage.vue?vue&type=style&index=0&id=46f77815&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f77815",
  null
  
)

export default component.exports